import t from "./_baseMatches.js";
import o from "./_baseMatchesProperty.js";
import f from "./identity.js";
import i from "./isArray.js";
import e from "./property.js";
function c(r) {
  return typeof r == "function" ? r : r == null ? f : typeof r == "object" ? i(r) ? o(r[0], r[1]) : t(r) : e(r);
}
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseIteratee.js
// module id = 1435
// module chunks = 41